/**
 * Fenice Italy Business API
 * # Fenice Italy Business API  ## General Http Status: HTTP STATUS CODE | DESCRIPTION --- | --- 400 | Business error or general error 401 | Expired token 403 | Access token does not have the required scope 404 | Not found 500 | Internal error  ## Specific Error Codes: Verti has specific errors based on validations, in error field *code*  CODE | DESCRIPTION --- | --- KOIT001 | Plate not valid from SIC/SITA. KOIT002 | Vehicle plate number is not valid. KOIT003 | Login failed. Password is not correct.  ## Annotations:   - In those services that return a list of items, in the case of not found any of them, it will return an empty list.   - For date format, standard ISO 8601. (YYYY-MM-DDThh:mm:ss.sTZD)
 *
 * OpenAPI spec version: 1.2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { TechnicalData } from './technicalData';

export interface PolicyVehicle {
  plateNumber?: string;
  puchaseYear?: number;
  infocarCode?: string;
  infocarDate?: Date;
  kmPerYear?: number;
  shelterType?: PolicyVehicle.ShelterTypeEnum;
  antitheftType?: PolicyVehicle.AntitheftTypeEnum;
  kw?: string;
  alimentation?: PolicyVehicle.AlimentationEnum;
  matriculationYearMonth?: string;
  habitualUse?: PolicyVehicle.HabitualUseEnum;
  type?: PolicyVehicle.TypeEnum;
  maker?: string;
  model?: string;
  ccCapacity?: number;
  version?: string;
  progrSetUp?: string;
  techincalData?: TechnicalData;
  immatricolazioneNoleggio?: boolean;
  trainoVeicolo?: boolean;
  usageVehicle?: PolicyVehicle.UsageVehicleEnum;
  typeUsageVehicle?: PolicyVehicle.TypeUsageVehicleEnum;
  massaPienoCarico?: number;
  loadCapacityA?: number;
  loadCapacityFrom?: number;
  volumeCargo?: number;
}
export namespace PolicyVehicle {
  export type ShelterTypeEnum = 'STRADA' | 'BOX_PRIVATO' | 'AREA_PRIVATA' | 'GARAGE';
  export const ShelterTypeEnum = {
    STRADA: 'STRADA' as ShelterTypeEnum,
    BOXPRIVATO: 'BOX_PRIVATO' as ShelterTypeEnum,
    AREAPRIVATA: 'AREA_PRIVATA' as ShelterTypeEnum,
    GARAGE: 'GARAGE' as ShelterTypeEnum,
  };
  export type AntitheftTypeEnum = 'NESSUNO' | 'IMMOBILIZER_SATELLITARE' | 'SOLO_ALLARME';
  export const AntitheftTypeEnum = {
    NESSUNO: 'NESSUNO' as AntitheftTypeEnum,
    IMMOBILIZERSATELLITARE: 'IMMOBILIZER_SATELLITARE' as AntitheftTypeEnum,
    SOLOALLARME: 'SOLO_ALLARME' as AntitheftTypeEnum,
  };
  export type AlimentationEnum = 'DIESEL' | 'METANO' | 'BENZINA' | 'GAS' | 'ELETTRICA' | 'IBRIDA';
  export const AlimentationEnum = {
    DIESEL: 'DIESEL' as AlimentationEnum,
    METANO: 'METANO' as AlimentationEnum,
    BENZINA: 'BENZINA' as AlimentationEnum,
    GAS: 'GAS' as AlimentationEnum,
    ELETTRICA: 'ELETTRICA' as AlimentationEnum,
    IBRIDA: 'IBRIDA' as AlimentationEnum,
  };
  export type HabitualUseEnum =
    | 'MISTO'
    | 'LAVORO'
    | 'TEMPO_LIBERO'
    | 'CommonGood'
    | 'SpecialVehicle'
    | 'AFFARI'
    | 'TRASPORTO_MERCI_COMUNI'
    | 'VEICOLO_SPECIALE_UFFICIO';
  export const HabitualUseEnum = {
    MISTO: 'MISTO' as HabitualUseEnum,
    LAVORO: 'LAVORO' as HabitualUseEnum,
    TEMPOLIBERO: 'TEMPO_LIBERO' as HabitualUseEnum,
    CommonGood: 'CommonGood' as HabitualUseEnum,
    SpecialVehicle: 'SpecialVehicle' as HabitualUseEnum,
    AFFARI: 'AFFARI' as HabitualUseEnum,
    TRASPORTOMERCICOMUNI: 'TRASPORTO_MERCI_COMUNI' as HabitualUseEnum,
    VEICOLOSPECIALEUFFICIO: 'VEICOLO_SPECIALE_UFFICIO' as HabitualUseEnum,
  };
  export type TypeEnum =
    | 'MOTOCICLO'
    | 'AUTO'
    | 'AUTOCARRI_FINO_35_QUINTALI'
    | 'CICLOMOTORE'
    | 'FUORI_STRADA'
    | 'NOT_VALID';
  export const TypeEnum = {
    MOTOCICLO: 'MOTOCICLO' as TypeEnum,
    AUTO: 'AUTO' as TypeEnum,
    AUTOCARRIFINO35QUINTALI: 'AUTOCARRI_FINO_35_QUINTALI' as TypeEnum,
    CICLOMOTORE: 'CICLOMOTORE' as TypeEnum,
    FUORISTRADA: 'FUORI_STRADA' as TypeEnum,
    NOTVALID: 'NOT_VALID' as TypeEnum,
  };
  export type UsageVehicleEnum = 'CONTO_PROPRIO' | 'CONTO_TERZI';
  export const UsageVehicleEnum = {
    PROPRIO: 'CONTO_PROPRIO' as UsageVehicleEnum,
    TERZI: 'CONTO_TERZI' as UsageVehicleEnum,
  };
  export type TypeUsageVehicleEnum = 'TRASPORTO_MERCI_COMUNI' | 'VEICOLO_SPECIALE_UFFICIO';
  export const TypeUsageVehicleEnum = {
    TRASPORTOMERCICOMUNI: 'TRASPORTO_MERCI_COMUNI' as TypeUsageVehicleEnum,
    VEICOLOSPECIALEUFFICIO: 'VEICOLO_SPECIALE_UFFICIO' as TypeUsageVehicleEnum,
  };
}
